import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ConsumoService {

  constructor(private http: HttpClientService) { }

  public getByIdZona(idZona) {
    let params = new HttpParams().set("idZona", idZona);
    return this.http.getWithParams('/consumo/getbyidzona', params);
  }

  public getMonthlyByIdZona(idZona, month, year) {
    let params = new HttpParams().set("idZona", idZona).set("month", month).set("year", year);
    return this.http.getWithParams('/consumo/getmonthlybyidzona', params);
  }

  public getLastFactoresConsumo(idEmpresa) {
    let params = new HttpParams().set("idEmpresa", idEmpresa);
    return this.http.getWithParams('/consumo/getlastfactoresconsumo', params);
  }

  public getConsumoTeoricoByIdProyecto(idProyecto) {
    let params = new HttpParams().set("idProyecto", idProyecto);
    return this.http.getWithParams('/consumo/getconsumoteoricobyidproyecto', params);
  }

  public newFactoresConsumo(factors, idUsuario) {

    let json =
      {
        "luminariaConsumoPorHora": factors.luminariaConsumoPorHora,
        "kwhToReducedTonCO2": factors.kwhToReducedTonCO2,
        "kwhToConsumedTonCO2": factors.kwhToConsumedTonCO2,
        "co2ToKilometer": factors.co2ToKilometer,
        "co2ToHouse": factors.co2ToHouse,
        "co2ToTree": factors.co2ToTree,
        "co2ToPhone": factors.co2ToPhone,
        "idUsuario": idUsuario
      };

    return this.http.post('/consumo/newfactoresconsumo', json);
  }

}
